import { createSlice } from '@reduxjs/toolkit'

const safeJSONParse = (data) => {
  try {
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('Error parsing stored data:', error);
    return null;
  }
};

const loadInitialState = () => {
  const storedUser = safeJSONParse(localStorage.getItem('user'));
  const storedToken = localStorage.getItem('token');
  
  return {
    mode: "light",
    user: storedUser,
    token: storedToken,
    posts: []
  };
};

const initialState = loadInitialState();

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserDetails: (state, action) => {
      if (action.payload) {
        // Ensure we have picturePath (your backend field)
        const normalizedUser = {
          ...action.payload,
          picturePath: action.payload.picturePath || action.payload.profilePic
        };
        state.user = normalizedUser;
        localStorage.setItem('user', JSON.stringify(normalizedUser));
      } else {
        state.user = null;
        localStorage.removeItem('user');
      }
    },
    setLogin: (state, action) => {
      if (action.payload) {
        const normalizedUser = {
          ...action.payload.user,
          picturePath: action.payload.user?.picturePath || action.payload.user?.profilePic
        };
        state.user = normalizedUser;
        state.token = action.payload.token;
        localStorage.setItem('user', JSON.stringify(normalizedUser));
        localStorage.setItem('token', action.payload.token);
      }
    },
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
    setToken: (state, action) => {
      state.token = action.payload;
      if (action.payload) {
        localStorage.setItem('token', action.payload);
      } else {
        localStorage.removeItem('token');
      }
    },
  //   setLogin: (state, action) =>{
  //     state.user = action.payload.user;
  //     state.token = action.payload.token;
  // },
  // setLogout: (state) => {
  //     state.user = null;
  //     state.token = null;           
  // },
  setFriends: (state, action) => {
  if (state.user) {
    state.user.friends = action.payload.friends;
  } else {
    console.log("User friends non-existent :(");
  }
},
  setUser: (state, action) => {
      state.user = action.payload;
  },  
  setPosts: (state, action) => {
      state.posts = action.payload.posts;
  },
  setPost: (state, action) =>{
      const updatedPosts = state.payload.map((post) => {
          if(post._id === action.payload._id){
              return action.payload.post;
          }
          return post;
      })
      state.posts = updatedPosts;
  },
    
  logout: (state) => {
    state.user = null;
    state.token = null;
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  }
  },
})

export const { setUserDetails,
               setToken, 
               logout,
               setFriends, 
               setUser, 
               setMode, 
               setLogin,                
               setPosts, 
               setPost, 
              } = userSlice.actions

export default userSlice.reducer